export function SourceFooter({ source, attribution, license, lastSyncedAt }: { source?: string | null; attribution?: string | null; license?: string | null; lastSyncedAt?: string | null }) {
  const date = lastSyncedAt ? new Date(lastSyncedAt).toLocaleDateString('fr-FR') : null;
  const bits = [attribution || source, license, date && `MAJ ${date}`].filter(Boolean);
  if (bits.length === 0) return null;
  return <p className="t-mono-xs text-ink-3">Source : {bits.join(' · ')}</p>;
}
